import PropTypes from 'prop-types';
import React from 'react';

export const ScalingInWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'SCALING_IN',
    category: 'Position',
    type: 'Scaling In',
    domain: 'Underlying',
  };
  const quantityBasisValue = softOrder.quantityBasisValue;
  const price = softOrder.price;
  return <Component details={details} price={price} quantityBasisValue={quantityBasisValue} {...rest}/>;
};

ScalingInWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    price: PropTypes.any,
    quantityBasisValue: PropTypes.any
  })
};

